import React from "react";
import SofortIcon from '../../../assets/svg/sofort.svg';
import FrameBlockResult from '../FrameBlockResult'
import { ApmsTypes } from "../../../constants";

const SofortResult = ({ link }) => {
    return (
        <FrameBlockResult link={link} apmType={ApmsTypes.Sofort} icon={SofortIcon} hideFrame={true} />
    )
}

export default SofortResult;